import React, {useEffect, useState} from "react";
import {PROSPECT} from "v4/data/entities";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import ListingEntityLayout from "v4/layouts/ListingEntityLayout/ListingEntityLayout";
import ListingHeaderEntityLayout from "v4/layouts/ListingHeaderEntityLayout/ListingHeaderEntityLayout";
import ProspectsListingActions
    from "v4/pages/front/Prospects/components/ProspectsListing/components/ProspectsListingActions/ProspectsListingActions";
import ProspectsListingMaps
    from "v4/pages/front/Prospects/components/ProspectsListing/components/ProspectsListingMaps/ProspectsListingMaps";
import ProspectsListingRowActions
    from "v4/pages/front/Prospects/components/ProspectsListing/components/ProspectsListingRowActions/ProspectsListingRowActions";
import ProspectsListingTools
    from "v4/pages/front/Prospects/components/ProspectsListing/components/ProspectsListingTools/ProspectsListingTools";
import {useHistory} from "react-router-dom";
import ProspectsListingStats
    from "v4/pages/front/Prospects/components/ProspectsListing/components/ProspectsListingStats/ProspectsListingStats";
import { useSearchContext } from "v4/contexts/SearchContext/SearchContext";
import { useNavigation } from "v4/features/front/navigation/contexts/NavigationContext";

export default function ProspectsListing() {
    const { tab } = useSearchContext();
    const {t} = usePolTranslation();
    const { replace } = useHistory();
    const { currentRoute, getRouteByNativeIdentifier } = useNavigation();
    const [totalItems, setTotalItems] = useState(null);
    const {alternativeListing} = currentRoute.params;

    const allowedAlternatives = currentRoute?.routeConfig?.alternatives || [];

    // Sécurité : Si l'alternative dans l'URL est inconnue, on redirige vers le listing de base
    useEffect(() => {
        if (alternativeListing && !allowedAlternatives.includes(alternativeListing)) {
            const mainRoute = getRouteByNativeIdentifier('main_prospects');
            if (mainRoute?.url) {
                replace(mainRoute.url.startsWith('/') ? mainRoute.url : `/${mainRoute.url}`);
            }
        }
    }, [alternativeListing, allowedAlternatives, getRouteByNativeIdentifier, replace]);

    return (
        <div className="page-list__content">
            <div className="table-container">
                <ListingHeaderEntityLayout totalItems={totalItems}
                                           title={tab?.label ?? t('comptes_prospects_clients')}
                                           pageType='prospects'
                                           resultsText={(t(`resultats_elements_prospect${(totalItems > 1) ? 's' : ''}`, {count: totalItems}))}
                                           actions={ProspectsListingActions}/>
                <ListingEntityLayout entity={PROSPECT}
                                     toolsRender={({checkedRows}) => <ProspectsListingTools alternativeListing={alternativeListing} checkedRows={checkedRows}/>}
                                     rowActions={ProspectsListingRowActions}
                                     tableClassName="prospects"
                                     alternateDisplay={getAlternateDisplayComponent(alternativeListing)}
                                     alternateDisplayOptions={{alternativeListing}}
                                     setTotalItems={setTotalItems} />
            </div>
        </div>
    )
}

function getAlternateDisplayComponent(alternativeListing) {
    switch (alternativeListing) {
        case 'maps':
            return ({entitiesList, isLoading}) => (
                <ProspectsListingMaps entitiesList={entitiesList} isLoading={isLoading}/>
            );
        case 'statistics':
            return ({isLoading}) => (
                <ProspectsListingStats isLoading={isLoading}/>
            );
        default:
            return null;
    }
}
